import { toast } from "react-toastify";

import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const syncScopes = async () => {
  const resp = await api.post("/v2/intelligems/sync-scopes", {});
  return resp.data;
};
export const useSyncScopes = () => {
  return useMutation({
    mutationFn: async () => syncScopes(),
    onSuccess: () => {
      toast.success("Sync Scopes Successful!");
    },
  });
};
